import React, { useMemo } from "react";
import { useFormikContext } from "formik";
import { useOutletContext } from "react-router-dom";
import BasicsSection from "./sections/BasicsSection";
import SpecsSection from "./sections/SpecsSection";
import VariationSection from "./sections/VariationSection";
import SeoSection from "./sections/SeoSection";
import ErrorSummary from "./ui/ErrorSummary";

const FIELD_LABELS = {
  name: "Name",
  ar_name: "Arabic Name",
  description: "Description",
  ar_description: "Arabic Description",
  quantity: "Quantity",
  barcode: "Barcode",
  category_ids: "Category",
  brand_ids: "Brand",
  images: "Images",
  cost: "Cost",
  regular_price: "Regular Price",
  sale_price: "Sale Price",
};

const flattenErrors = (errors, touched, prefix = "") => {
  const out = [];
  for (const key of Object.keys(errors || {})) {
    const path = prefix ? `${prefix}.${key}` : key;
    const err = errors[key];
    const isTouched =
      touched &&
      (prefix
        ? prefix.split(".").reduce((acc, k) => acc?.[k], touched)?.[key]
        : touched[key]);
    if (typeof err === "string") {
      if (isTouched) {
        out.push({
          name: path,
          label: FIELD_LABELS[path] ?? path,
          message: err,
        });
      }
    } else if (err && typeof err === "object") {
      out.push(...flattenErrors(err, touched, path));
    }
  }
  return out;
};

const GeneralScreen = () => {
  const { errors, submitCount } = useFormikContext();
  // Update passes the loaded product through the outlet; Add passes nothing,
  // so the SEO boxes there keep their static hints.
  const { singleProduct } = useOutletContext() || {};

  const errorList = useMemo(() => {
    if (submitCount === 0) return [];
    const forceTouched = Object.keys(errors).reduce((acc, k) => {
      acc[k] = true;
      return acc;
    }, {});
    return flattenErrors(errors, forceTouched);
  }, [errors, submitCount]);

  return (
    <>
      <ErrorSummary errors={errorList} />
      <BasicsSection />
      <SpecsSection />
      <VariationSection />
      <SeoSection autoSeo={singleProduct?.seo_auto} />
    </>
  );
};

export default GeneralScreen;
